import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSupperFundHome } from '../action/investmentAction';
import ModalSelect from './Modal/ModalSelect';

import { getStorage, setStorage } from '../common';
import { hashHistory } from 'react-router';
import {
  getPayAll,
  goHXJJLogin,
  goLogin
} from '../getPay';
//http://localhost:3000/#/SubscriptionDetail?enterType=SubscriptionDetail
class SubscriptionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  callBack(){

  }
  componentWillMount() {
    let { dispatch } = this.props;
    dispatch(getSupperFundHome({},this.callBack,this))
  }
  goPay(){
    var params = {
      fundName: "华夏3年封闭运作战略配售",
      fundCode:'501186',
      businessType:'T020',
      productType:'G',
      fundType:'股票型',
      enterType:'SubscriptionDetail'
    }
    let fun=()=>{
      getPayAll(window.history.length,params, hashHistory, 'Payment')
    }
    goHXJJLogin(fun, window.history.length);
  }
  Process(){
    hashHistory.push({
      pathname:'/SubscriptionDetailTwo',
      state:{
        pathname:'/SubscriptionDetailTwo'
      },
      query:{
        enterType:'SubscriptionDetail'
      }
    })
  }
  render(){
    let { SupperFundHome } = this.props;
    console.log(SupperFundHome);
    return (
        <div style={{flex:1}}>
          <div style={{width:window.screen.width, height:window.screen.width*(7449/645)}} className="SubscriptionDetailBanner" >
            
          </div>
          <div style={{height:40, width:"100%"}}></div>
          <div style={{ height:40, display: "-webkit-flex", WebkitFlexDirection:'row', position:"fixed", bottom:0, width:"100%",  }}>
            <div onClick = { ()=> this.Process() } style={{ WebkitFlex:2,borderTop:'#e1e3e6 solid 1px',display: "-webkit-flex", WebkitJustifyContent:'center', WebkitAlignItems:'center', background:"#FFF" }} >
                <div style={{ fontSize:'0.3rem',color:'rgb(90,99,112)' }}>了解投资流程</div>
            </div>
            <div onClick={()=>this.goPay()} style={{WebkitFlex:2, height:40, backgroundColor:"#fa063a", color:'#FFF', fontSize:'0.3rem',display: "-webkit-flex", WebkitJustifyContent:'center', WebkitAlignItems:'center' }}>
                <span>立即认购</span>
            </div>
          </div>
          <ModalSelect/>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome:state.SupperFundHome
  }
}
export default connect(mapStateToProps)(SubscriptionDetail);



// WEBPACK FOOTER //
// ./src/components/SubscriptionDetail.js